import { setFullWindow } from '../actions/layout'
import { TransitionTypes, motionTransition } from '../utilities/transitions'
import { MODALSTATE } from './modals'
import { closeTopFloater } from './modals/state.floater'
import { LAYOUTSTATE } from './state.layout'
import { AppRouter } from './state.router'

export enum KeyEvent {
    Keydown = 'keydown',
    // Keyup = 'keyup',
    // Keypress = 'keypress',
}

export type Handler = {
    key: string[] // key to match on
    // modKeys: string[] // ctrl alt shift meta keys??
    exclusive: boolean // should this handler take priority and be the only listener for this?
    callback: (key: string) => any //(e: KeyboardEvent) => any
}
export interface KeyHandlers {
    keydown: Array<Handler>
    // keyup: Array<Handler>
    // keypress: Array<Handler>
}

export const KEY_HANDLERS: KeyHandlers = {
    keydown: [],
    // keyup: [],
    // keypress: [],
}

const GLOBAL_HANDLERS = {
    [KeyEvent.Keydown]: {
        Escape: () => {
            // exit full window
            if (
                MODALSTATE.floating_room.show &&
                MODALSTATE.floating_room.state.id
            ) {
                motionTransition(() => setFullWindow(false, true), {
                    id: MODALSTATE.floating_room.state.id,
                    transitionSource: TransitionTypes.ROOM,
                    transitionDestination: AppRouter.route.lastTransitionSource,
                })
            }
            // close top floater
            closeTopFloater()
        },
    },
    // [KeyEvent.Keypress]: {

    // },
    // [KeyEvent.Keyup]: {

    // }
}

export const registerKeyHandler = (
    eventType: KeyEvent = KeyEvent.Keydown,
    handler: (key: string) => any, //(e: KeyboardEvent) => any,
    key: string[],
    options?: { /*modKeys?: string[];*/ exclusive?: boolean },
) => {
    const { exclusive = false } = options || {}
    const existing = KEY_HANDLERS[eventType]
    const keyHandler = { key, exclusive, callback: handler }
    // if its `exclusive`, put it first in the array
    if (exclusive) {
        KEY_HANDLERS[eventType] = [keyHandler].concat(existing)
    } else {
        KEY_HANDLERS[eventType] = existing.concat(keyHandler)
    }
    return () => {
        //deregister
        const index = KEY_HANDLERS[eventType].findIndex((h) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            h.callback === handler
        })
        KEY_HANDLERS[eventType].splice(index, 1)
    }
}

if (typeof window !== 'undefined') {
    // window.__MFC_APP_KEYS__ =
    const mainHandler = (eventType: KeyEvent) => (event: KeyboardEvent) => {
        // console.log(
        //     '[keys mainHandler]',
        //     {
        //         eventType,
        //         key: event.key,
        //         composeFocused: LAYOUTSTATE.portal.composeFocused,
        //     },
        //     KEY_HANDLERS[eventType],
        // )
        if (LAYOUTSTATE.portal.composeFocused) return
        const handlers = KEY_HANDLERS[eventType]
        let foundExclusive = false
        handlers.forEach((handler) => {
            if (handler.key.includes(event.key)) {
                if (foundExclusive) return
                handler.callback(event.key)
                if (handler.exclusive) {
                    foundExclusive = true
                }
            }
        })
        if (foundExclusive) return
        // global handlers
        const globalHandler = GLOBAL_HANDLERS[eventType][event.key]
        globalHandler?.()
    }
    window.document.addEventListener(
        KeyEvent.Keydown,
        mainHandler(KeyEvent.Keydown),
        { passive: true },
    )
    // window.document.addEventListener(
    //     KeyEvent.Keyup,
    //     mainHandler(KeyEvent.Keyup),
    //     { passive: true },
    // )
    // window.document.addEventListener(
    //     KeyEvent.Keypress,
    //     mainHandler(KeyEvent.Keypress),
    //     { passive: true },
    // )
}
